module.exports = __webpack_public_path__ + "media/images/companyPage/diversity-944b94281a0fd18361a6bcff65cd5cdc.svg";